
export class statusRemark {
    id:number;
    modeOfStudy: string;
    status :string;
    remark :string;
    verifiedby:string;
    roleid : string;
    cgpi: string;
    newremark: string;
    editreason;
    }